// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The logged-in footer's chrome, kept deliberately identical to the logged-out
   LoginBuildChip.module.css. The two footers sit on opposite sides of the login
   boundary and should not feel like different products; this one used to be a
   tighter py={6} bar with real <Divider>s and 14px copy, which is what made it
   read as heavier and older than the login page's.

   If you change a value here, change it in LoginBuildChip.module.css too. They
   are duplicated rather than shared because the two components have different
   content and lifecycles -- only the surface treatment is common. */

.JgUDdErhvlluTnxxFJjw {
    border-top: 1px solid var(--mantine-color-gray-2);
    background: var(--mantine-color-white);
    padding: 16px 24px;
}

.DBrKmyAb9D51_GkqpuQt {
    margin: 0 auto;
}

.U5u15nTivTaEgoXU5Ybb {
    color: var(--mantine-color-gray-3);
}

.HeKkxu8rUgPMuj1qpETV {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
    font-family: var(--mantine-font-family-monospace);
    font-size: 11px;
    color: var(--mantine-color-gray-6);
}

.HeKkxu8rUgPMuj1qpETV:hover {
    color: var(--mantine-color-gray-7);
}

.zP4Uvn0HsfScDxAufgmN {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--mantine-color-green-6);
    flex: 0 0 auto;
}

.bh1vJ45PDKV449df8mIe {
    margin: 12px auto 0;
    border-top: 1px dashed var(--mantine-color-gray-2);
    padding-top: 12px;
}

/* Build/timing identities only -- monospace reads as "diagnostic", which is
   right for a copyable id but wrong for the support links below, which are
   ordinary prose a user reads and clicks. */
.Vq5jLZ7zrUQA1hw4Ga5i {
    font-family: var(--mantine-font-family-monospace);
    font-size: 11px;
    color: var(--mantine-color-gray-5);
}

.cKZUZaXpWSrwgF886BAb {
    color: var(--mantine-color-gray-6);
}

@media (max-width: 48em) {
    .JgUDdErhvlluTnxxFJjw {
        padding: 16px 20px 24px;
    }
}

/* Build identity rows. Laid out as buttons because their job is click-to-copy;
   they stay visually inert until hovered so the drawer still reads as text. */
.gxcGNtjGkv9j_nX4RolQ {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-family: var(--mantine-font-family-monospace);
    font-size: 11px;
    color: var(--mantine-color-gray-5);
    cursor: pointer;
}

.gxcGNtjGkv9j_nX4RolQ:disabled {
    cursor: default;
}

.urNBCObi8ieo_KA8SyUU {
    color: var(--mantine-color-gray-6);
}

.OFnB3SARrZE2JsGJytcy {
    color: var(--mantine-color-gray-7);
}

.gxcGNtjGkv9j_nX4RolQ:hover:not(:disabled) .OFnB3SARrZE2JsGJytcy {
    color: var(--mantine-color-brand-6);
    text-decoration: underline;
}

/* Reserved rather than revealed, so hovering a row does not reflow the ones
   beside it. */
.taLQvndINvW829eZg1hj {
    min-width: 3.2em;
    color: var(--mantine-color-gray-4);
    visibility: hidden;
}

.gxcGNtjGkv9j_nX4RolQ:hover:not(:disabled) .taLQvndINvW829eZg1hj {
    visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./Components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;;;;;;;;oEAQoE;;AAEpE;IACI,iDAAiD;IACjD,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iDAAiD;IACjD,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;;4CAE4C;AAC5C;IACI,iDAAiD;IACjD,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;8EAC8E;AAC9E;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,iDAAiD;IACjD,eAAe;IACf,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;eACe;AACf;IACI,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* The logged-in footer's chrome, kept deliberately identical to the logged-out\n   LoginBuildChip.module.css. The two footers sit on opposite sides of the login\n   boundary and should not feel like different products; this one used to be a\n   tighter py={6} bar with real <Divider>s and 14px copy, which is what made it\n   read as heavier and older than the login page's.\n\n   If you change a value here, change it in LoginBuildChip.module.css too. They\n   are duplicated rather than shared because the two components have different\n   content and lifecycles -- only the surface treatment is common. */\n\n.root {\n    border-top: 1px solid var(--mantine-color-gray-2);\n    background: var(--mantine-color-white);\n    padding: 16px 24px;\n}\n\n.row {\n    margin: 0 auto;\n}\n\n.sep {\n    color: var(--mantine-color-gray-3);\n}\n\n.chip {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 0;\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 11px;\n    color: var(--mantine-color-gray-6);\n}\n\n.chip:hover {\n    color: var(--mantine-color-gray-7);\n}\n\n.dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--mantine-color-green-6);\n    flex: 0 0 auto;\n}\n\n.drawer {\n    margin: 12px auto 0;\n    border-top: 1px dashed var(--mantine-color-gray-2);\n    padding-top: 12px;\n}\n\n/* Build/timing identities only -- monospace reads as \"diagnostic\", which is\n   right for a copyable id but wrong for the support links below, which are\n   ordinary prose a user reads and clicks. */\n.diagnostics {\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 11px;\n    color: var(--mantine-color-gray-5);\n}\n\n.supportLink {\n    color: var(--mantine-color-gray-6);\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n    .root {\n        padding: 16px 20px 24px;\n    }\n}\n\n/* Build identity rows. Laid out as buttons because their job is click-to-copy;\n   they stay visually inert until hovered so the drawer still reads as text. */\n.copyRow {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 11px;\n    color: var(--mantine-color-gray-5);\n    cursor: pointer;\n}\n\n.copyRow:disabled {\n    cursor: default;\n}\n\n.copyLabel {\n    color: var(--mantine-color-gray-6);\n}\n\n.copyValue {\n    color: var(--mantine-color-gray-7);\n}\n\n.copyRow:hover:not(:disabled) .copyValue {\n    color: var(--mantine-color-brand-6);\n    text-decoration: underline;\n}\n\n/* Reserved rather than revealed, so hovering a row does not reflow the ones\n   beside it. */\n.copyHint {\n    min-width: 3.2em;\n    color: var(--mantine-color-gray-4);\n    visibility: hidden;\n}\n\n.copyRow:hover:not(:disabled) .copyHint {\n    visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JgUDdErhvlluTnxxFJjw`,
	"row": `DBrKmyAb9D51_GkqpuQt`,
	"sep": `U5u15nTivTaEgoXU5Ybb`,
	"chip": `HeKkxu8rUgPMuj1qpETV`,
	"dot": `zP4Uvn0HsfScDxAufgmN`,
	"drawer": `bh1vJ45PDKV449df8mIe`,
	"diagnostics": `Vq5jLZ7zrUQA1hw4Ga5i`,
	"supportLink": `cKZUZaXpWSrwgF886BAb`,
	"copyRow": `gxcGNtjGkv9j_nX4RolQ`,
	"copyLabel": `urNBCObi8ieo_KA8SyUU`,
	"copyValue": `OFnB3SARrZE2JsGJytcy`,
	"copyHint": `taLQvndINvW829eZg1hj`
};
export default ___CSS_LOADER_EXPORT___;
